import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = { class: "text-2xl font-bold text-dashboard-text leading-none" }
const _hoisted_4 = { class: "text-xs text-dashboard-muted mt-1 truncate" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatCard',
  props: {
    label: {},
    value: {},
    icon: {},
    tone: {}
  },
  setup(__props: any) {

const props = __props

const TONES: Record<string, { bg: string; text: string; border: string }> = {
  slate:   { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-dashboard-border' },
  amber:   { bg: 'bg-amber-50',   text: 'text-amber-600',   border: 'border-amber-200' },
  red:     { bg: 'bg-red-50',     text: 'text-red-600',     border: 'border-red-200' },
  indigo:  { bg: 'bg-indigo-50',  text: 'text-indigo-600',  border: 'border-dashboard-border' },
  emerald: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-dashboard-border' },
  blue:    { bg: 'bg-blue-50',    text: 'text-blue-600',    border: 'border-dashboard-border' },
}

const toneBg = computed(() => TONES[props.tone || 'slate'].bg)
const toneText = computed(() => TONES[props.tone || 'slate'].text)
const toneBorder = computed(() => TONES[props.tone || 'slate'].border)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bg-white border rounded-xl p-4 shadow-sm', toneBorder.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['p-2 rounded-lg', toneBg.value])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
          class: _normalizeClass(['w-5 h-5', toneText.value])
        }, null, 8, ["class"]))
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.value), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.label), 1)
      ])
    ])
  ], 2))
}
}

})